import ls from 'helpers/local-storage';

const SEEN_KEY = 'sku_modifier_hidden_group_modal_seen';

export const hasSeenHiddenGroupModal = () => Boolean(ls.get(SEEN_KEY, false));

export const markHiddenGroupModalSeen = () => ls.set(SEEN_KEY, true);
